import request from '@/utils/request'


// 查询用户心电ECG记录列表
export function listEcg(query) {
  return request({
    url: '/joe/user-ecg/list',
    method: 'get',
    params: query
  })
}

// 查询用户心电ECG记录分页
export function pageEcg(query) {
  return request({
    url: '/joe/user-ecg/page',
    method: 'get',
    params: query
  })
}

// 查询用户心电ECG记录详细
export function getEcg(data) {
  return request({
    url: '/joe/user-ecg/detail',
    method: 'get',
    params: data
  })
}

// 新增用户心电ECG记录
export function addEcg(data) {
  return request({
    url: '/joe/user-ecg/add',
    method: 'post',
    data: data
  })
}

// 修改用户心电ECG记录
export function updateEcg(data) {
  return request({
    url: '/joe/user-ecg/edit',
    method: 'post',
    data: data
  })
}

// 删除用户心电ECG记录
export function delEcg(data) {
  return request({
    url: '/joe/user-ecg/delete',
    method: 'post',
    data: data
  })
}
